var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vertical-wrapper"},[_c('h1',[_vm._v("Demo Zugänge")]),_c('div',{ref:"demo-access-list"})])}
var staticRenderFns = []

export { render, staticRenderFns }